import { Box } from '@mui/material';

export const LIS = () => {
  return <Box sx={{ flex: 1 }}></Box>;
};
